/**
 * External links used in the contact form
 */
export const CONTACT_FORM_LINKS = {
    TERMS_OF_USE: 'https://biamba.co.il/terms/?_gl=1*1tjuyix*_up*MQ..*_gs*MQ..&gclid=CjwKCAiAncvMBhBEEiwA9GU_fo3hbnqeVplUsBHlNFq76sROKmEtZU4ViLFCCBBCsmDOcGTnHozFaxoCYDQQAvD_BwE&gbraid=0AAAAABzAao8ZG1q34_1Jty4vQSf5OQMJr',
    PRIVACY_POLICY: 'https://biamba.co.il/privacy-policy/?_gl=1*1tjuyix*_up*MQ..*_gs*MQ..&gclid=CjwKCAiAncvMBhBEEiwA9GU_fo3hbnqeVplUsBHlNFq76sROKmEtZU4ViLFCCBBCsmDOcGTnHozFaxoCYDQQAvD_BwE&gbraid=0AAAAABzAao8ZG1q34_1Jty4vQSf5OQMJr',
};
